// Gate every /app route behind Firebase Auth + allowed-UID check.
//
// Four states:
//   0. VITE_AUTH_DISABLED — local-first mode against `roast serve`; pass.
//   1. Still loading Firebase's auth state — render a blank. Avoids a flash
//      of the login page while `onAuthStateChanged` is resolving.
//   2. Signed out — redirect to /login.
//   3. Signed in but uid != allowed — show a terminal "not authorized" card
//      instead of looping through login.

import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../auth";

export function Protected({ children }: { children: ReactNode }) {
  const { user, loading, authorized, authDisabled, signOut } = useAuth();

  if (authDisabled) {
    return <>{children}</>;
  }
  if (loading) {
    return null;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (authorized === false) {
    return (
      <div className="container">
        <div className="err-box">
          <strong>Not authorized.</strong>
          <div className="small muted">
            This RoastMCP instance is locked to a single operator. Your Google
            account ({user.email}) isn't on the allow list.
          </div>
          <div style={{ marginTop: 10 }}>
            <button className="secondary" onClick={() => void signOut()}>
              Sign out
            </button>
          </div>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
